<template id="dlgRenderShinTmpl" >
  <v-dialog v-model="dlgMapRenderShinIsOpen" fullscreen hide-overlay transition="dialog-bottom-transition" >
      <v-card>
        <v-toolbar color="primary" dark absolute left style="width: 100%">
            <v-btn icon dark v-on:click="closeMapRenderShin()"><v-icon>close</v-icon></v-btn>
            <v-toolbar-title v-if="mapDetailObj != null">
              {{mapDetailObj.map_name}}
              
              <v-btn 
                  class="mr-2" 
                  color="secondary" 
                  fab small bottom right absolute 
                  v-if="isEmptyObj(mapDetailObj) == false && isEmptyString(mapDetailObj.map_link) == false"
                  v-on:click="openMapLink(mapDetailObj.map_link)" >
                      <v-icon style="color:#000;" >list_alt</v-icon>
                </v-btn> 
                
            </v-toolbar-title>
            <v-toolbar-title v-else>{{$t('err.mapSelectedNotValid')}}</v-toolbar-title>
        </v-toolbar>
        <div v-if="isEmptyObj(mapDetailObj) == false && dlgMapRenderShinIsOpen == true">
            <div class="shinIframeContainer">
                <iframe
                  v-if="mapDetailObj != null"
                  width="100%"
                  height="100%"
                  v-bind:src="map_asset_complete"
                  frameborder="0"
                  allowfullscreen="true"
                  webkitallowfullscreen="true"
                  mozallowfullscreen="true"
                  style="width:100%"
                ></iframe>
            </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
    i18n,
    data: () => ({
      dlgMapRenderShinIsOpen: false,
      map_asset_complete: null,
      mapDetailObj: null
    }),
    methods: {
      openMapRenderShin(orgid, siteid, mapDetailObj) 
      {
        if(this.isEmptyString(orgid))  
        {
          this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
        }
        else if(this.isEmptyString(siteid)) 
        {
          this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
        } 
        else if(this.isEmptyObj(mapDetailObj)) 
        {
          this.$root.setDialogMsg(i18n.t("err.mapSelectedNotValid"));
        } 
        else 
        {
          this.mapDetailObj = mapDetailObj;
          
          if(!this.isEmptyString(this.mapDetailObj.map_asset)) 
          {
            if(this.mapDetailObj.map_asset_type == 'render3d_pro') 
            {
              this.dlgMapRenderShinIsOpen = true;
              this.map_asset_complete = this.mapDetailObj.map_asset
              this.map_asset_complete += "&org=" + orgid;
              this.map_asset_complete += "&site=" + siteid;
              this.map_asset_complete += "&map=" + this.mapDetailObj.sitemap_id;
              this.map_asset_complete += "&token=" + this.getUserAccessToken();
              console.log(this.map_asset_complete);
              events.$emit(constants.EVENT_DIALOG_RENDER_3D_OPEN);
            } 
            else if(this.mapDetailObj.map_asset_type == 'render3d_basic') 
            {
              this.dlgMapRenderShinIsOpen = true;
              this.map_asset_complete = constants. RENDER3D_BASIC_GALLERY_URL
              this.map_asset_complete += "&org=" + orgid;
              this.map_asset_complete += "&site=" + siteid;
              this.map_asset_complete += "&map=" + this.mapDetailObj.sitemap_id;
              this.map_asset_complete += "&obj=" + this.mapDetailObj.map_asset;
              this.map_asset_complete += "&token=" + this.getUserAccessToken();
              console.log(this.map_asset_complete);
              events.$emit(constants.EVENT_DIALOG_RENDER_3D_OPEN);
            } 
            else
            {
              this.$root.setDialogMsg(i18n.t("err.assetTypeNotValid"));
            } 
          } 
          else 
          {
             this.$root.setDialogMsg(i18n.t("err.mapAssetNotValid"));
          }
        }
      },
      closeMapRenderShin() 
      {
        this.map_asset_complete = null;
        this.dlgMapRenderShinIsOpen = false;
        events.$emit(constants.EVENT_DIALOG_RENDER_3D_CLOSE);
      },
    }
};
</script>